import { useEffect, useState } from 'react'

import { AgencyV2ClientPageLayout } from 'components/layouts/AgencyV2ClientPageLayout'

import CommercialUploader from '../CommercialUploader'
import { useParams } from 'react-router-dom'

interface AgencyV2UploadCommercialPageParams {
  step: string
}

enum AgencyV2UploadCommercialStep {
  Upload = 'upload',
}

export const AgencyV2CreateAdTvRetailPage = () => {
  const { step } = useParams<AgencyV2UploadCommercialPageParams>()
  const [helmetTitle, setHelmetTitle] = useState('')
  const [panelTitle, setPanelTitle] = useState('')

  useEffect(() => {
    switch (step) {
      case AgencyV2UploadCommercialStep.Upload:
        setHelmetTitle('Upload Commercial')
        setPanelTitle('Upload Commercial')
        break
    }
  }, [step])

  return (
    <AgencyV2ClientPageLayout helmetTitle={helmetTitle} panelTitle={panelTitle}>
      {step === AgencyV2UploadCommercialStep.Upload && <CommercialUploader />}
    </AgencyV2ClientPageLayout>
  )
}
